import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";

import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CloseIcon from "@mui/icons-material/Close";
import { TabView, TabPanel } from "primereact/tabview";
import axios from "axios";
import formattedDate from "../../formatDate";
import { Dialog } from "primereact/dialog";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import "primeicons/primeicons.css";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { Tag } from "primereact/tag";
import mapEtatFiche from "../../mapEtatFiche";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { fr } from "date-fns/locale";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { TextField, TextareaAutosize } from "@mui/material";
import formatToISODate from "../../formatDateISO";
import { useParams } from "react-router-dom";
import FicheLogTerminal from "../../ficheDemande/journal";
import PdfButton from ".././pdfGenerator";
import { updateEnLigne } from "../projetService";

const apiUrl = process.env.REACT_APP_API_URL;

// const userRole = localStorage.getItem("us");
// const canSelect = userRole === "admin" || userRole === "dev";
const canSelect = true;

export default function ToutesCat() {
  const [copied, setCopied] = useState(false);
  const [copiedText, setCopiedText] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const [dateMAJ, setDateMAJ] = useState("");
  const [infoMAJ, setInfoMAJ] = useState("");

  const { idtally } = useParams();

  const [rechercheToute, setRechercheToute] = useState("");

  const [projetsToute, setProjetsToute] = useState([]);

  const [projet, setProjet] = useState([]);

  const [filtreToute, setFiltreToute] = useState([]);

  const [visible, setVisible] = useState(false);

  const [etat, setEtat] = useState([]);
  const [note, setNote] = useState([]);
  const [infoSup, setInfoSup] = useState([]);

  const [tempIdProjet, setTempIdProjet] = useState([]);
  const [tempNom, setTempNom] = useState([]);
  const [tempTel, setTemptel] = useState([]);
  const [tempEmail, setTempEmail] = useState([]);
  const [tempAdresse, setTempAdresse] = useState([]);
  const [tempBesoin, setTempBesoin] = useState([]);

  const [rowClick, setRowClick] = useState(true);
  const [selectedRows, setSelectedRows] = useState([]);

  const [confirmVisible, setConfirmVisible] = useState(false);
  const [rowsToDelete, setRowsToDelete] = useState([]);

  useEffect(() => {
    if (!idtally) return;
    fetch(`${apiUrl}IHM/api/zotProjets.php?idtally=${idtally}&toute=1`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setProjetsToute(data.projets);
        }
      })
      .catch((err) => console.error(err));
  }, [idtally]);

  useEffect(() => {
    const rechercheMin = rechercheToute.toLowerCase();
    const filteredList = projetsToute.filter((projet) => {
      const nom = projet.nom_prenom?.toLowerCase() || "";
      const telephone = projet.telephone?.toLowerCase() || "";
      const mail = projet.email?.toLowerCase() || "";

      return (
        nom.includes(rechercheMin) ||
        telephone.includes(rechercheMin) ||
        mail.includes(rechercheMin)
      );
    });
    setFiltreToute(filteredList);
  }, [rechercheToute, projetsToute]);

  const enteteTableau5 = () => {
    return (
      <div className="flex justify-content-end">
        {selectedRows.length > 0 && (
          <Button
            icon="pi pi-trash"
            rounded
            text
            size="small"
            severity="danger"
            onClick={() => setConfirmVisible(true)}
          />
        )}
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search" />
          <InputText
            value={rechercheToute}
            onChange={(e) => setRechercheToute(e.target.value)}
            placeholder="Rechercher"
          />
        </IconField>
      </div>
    );
  };

  const copyToClipboard = (text) => {
    if (text !== "") {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            setCopiedText(text);
            setOpenSnackbar(true);
          })
          .catch((error) => {
            console.error(
              "Erreur lors de la copie dans le presse-papiers : ",
              error
            );
          });
      } else {
        // Utiliser l'API de sélection de texte comme solution de secours
        const textArea = document.createElement("textarea");
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("copy");
        document.body.removeChild(textArea);

        setCopiedText(text);
        setOpenSnackbar(true);
      }
    }
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const setInfoClick = (idProjet) => {
    setTempIdProjet("");
    setNote("");
    setEtat("");
    setDateMAJ("");
    setInfoMAJ("");
    setInfoSup("");

    axios
      .get(`${apiUrl}IHM/api/zotProjets.php?idProjet=${idProjet}`)
      .then((response) => {
        const data = response.data;

        setTempIdProjet(idProjet);
        if (data.success && data.projets && data.projets.length > 0) {
          const projet = data.projets[0];

          setProjet(projet);

          setEtat(projet.etat);

          setDateMAJ(projet.dateUpdate);
          setInfoMAJ(projet.adminMod);

          setTempNom(projet.value_1);
          setTemptel(projet.telephone);
          setTempEmail(projet.email);
          setTempAdresse(projet.value_4);
          setInfoSup(projet.infoSup);

          setVisible(true);
        } else {
          console.error("Aucun projet trouvé");
        }
      })
      .catch((error) => {
        console.error(
          "Une erreur s'est produite lors de la récupération de la fiche :",
          error
        );
      });
  };

  const handleSavePhoneCall = async () => {
    try {
      const response = await axios.put(`${apiUrl}IHM/api/zotProjets.php`, {
        idProjet: tempIdProjet,
        etat: etat,
        note: note,
        infoSup: infoSup,
        adminMod: localStorage.getItem("us"),
      });

      if (response.data.success) {
        window.location.reload();
      } else {
        alert("Erreur : " + response.data.message);
      }
    } catch (error) {
      console.error(
        "Erreur lors de la sauvegarde de l'appel téléphonique",
        error
      );
    }
  };

  
  const mettreEnligne = async (rowData, checked) => {
    try {
      const newValue = await updateEnLigne(apiUrl, rowData.id, checked);
  
      const updated = projetsToute.map((p) =>
        p.id === rowData.id ? { ...p, enLigne: newValue } : p
      );
      setProjetsToute(updated);
    } catch (err) {
      console.error(err);
    }
  };
  

  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={openSnackbar}
        autoHideDuration={1000}
        onClose={handleCloseSnackbar}
        message={`Copie réussie de " ${
          copiedText === "location.mail" ? "e-mail" : copiedText
        } "`}
        action={
          <React.Fragment>
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={handleCloseSnackbar}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </React.Fragment>
        }
      />

      <Dialog
        header="Confirmation de suppression"
        visible={confirmVisible}
        style={{ width: "400px" }}
        modal
        footer={
          <div>
            <Button
              label="Annuler"
              size="small"
              text
              icon="pi pi-times"
              onClick={() => setConfirmVisible(false)}
              className="p-button-text"
            />
            <Button
              label="Supprimer"
              icon="pi pi-trash"
              size="small"
              text
              severity="danger"
              onClick={async () => {
                setConfirmVisible(false);

                const idsBase5 = [];
                const tallyToDelete = [];

                for (const row of selectedRows) {
                  const idProjet = row.id;

                  try {
                    const res = await axios.get(
                      `${apiUrl}IHM/api/zotProjets.php?idProjet=${idProjet}`
                    );
                    const data = res.data;

                    if (
                      data.success &&
                      data.projets &&
                      data.projets.length > 0
                    ) {
                      const projet = data.projets[0];
                      const formId = projet.id_cat;

                      idsBase5.push(idProjet);

                      if (projet.idSubmissions && formId) {
                        tallyToDelete.push({
                          formId,
                          idSub: projet.idSubmissions,
                        });
                      }
                    }
                  } catch (e) {
                    console.error("Erreur récupération projet :", e);
                  }
                }

                try {
                  const resDelete = await axios.post(
                    `${apiUrl}IHM/api/deleteProjet.php`,
                    {
                      idsBase5,
                      tally: tallyToDelete,
                    }
                  );

                  setFiltreToute((prev) =>
                    prev.filter((row) => !idsBase5.includes(row.id))
                  );
                  setSelectedRows([]);
                } catch (err) {
                  console.error("Erreur suppression globale :", err);
                }
              }}
            />
          </div>
        }
        onHide={() => setConfirmVisible(false)}
      >
        <p>
          Voulez-vous vraiment supprimer {selectedRows.length} projet(s) ? Cette
          action est irréversible.
        </p>
      </Dialog>

      <Dialog
        visible={visible}
        onHide={() => setVisible(false)}
        header="Fiche de projet"
        className="custom-dialog"
        style={{ width: "45vw" }}
        modal
        breakpoints={{ "960px": "100vw", "640px": "100vw" }}
      >
        <div className="p-3">
          <div className="grid">
            {/* Etat actuel */}
            <div className="col-12 md:col-6">
              <div className="p-2 px-0 surface-100 border-round-sm flex justify-between align-items-left">
                <span className="font-bold">État actuel :</span>
                <span
                  className="p-1 px-2 text-sm"
                  style={{ background: "#e5e7eb", borderRadius: "5px" }}
                >
                  {mapEtatFiche(etat)}
                  <small></small>
                </span>
              </div>
            </div>

            {/* Etat souhaité */}
            <div className="col-12 md:col-6">
              <div className="p-2 px-0 surface-100 border-round-sm flex justify-between align-items-left">
                <span className="font-bold">État souhaité :</span>
                <Select
                  labelId="etat-label"
                  id="etat-select"
                  value={etat}
                  onChange={(e) => setEtat(e.target.value)}
                  displayEmpty
                  style={{
                    minWidth: "130px",
                    maxWidth: "130px",
                    maxHeight: "20px",
                  }}
                >
                  <MenuItem value="0" disabled>
                    Séléctionner un état
                  </MenuItem>
                  <MenuItem value="4">Répondeur</MenuItem>
                  <MenuItem value="1">En cours</MenuItem>
                  <MenuItem value="2">Traités</MenuItem>
                  <MenuItem value="3">Abandonnés</MenuItem>
                </Select>

                {copied ? (
                  <span
                    style={{
                      marginLeft: "12px",
                      fontSize: "14px",
                    }}
                  >
                    Copié !
                  </span>
                ) : (
                  <ContentCopyIcon
                    onClick={() => {
                      let agendaText = "";

                      Object.keys(projet).forEach((key) => {
                        if (key.startsWith("title_") && projet[key]) {
                          const idx = key.split("_")[1];
                          const valueKey = `value_${idx}`;

                          if (projet[valueKey]) {
                            const title = projet[key]
                              .trim()
                              .replace(/\s+/g, " ");
                            const value = projet[valueKey].trim();
                            agendaText += `${title} : ${value}\n`;
                          }
                        }
                      });

                      if (!agendaText) {
                        agendaText = "Aucune donnée projet à copier.";
                      }

                      navigator.clipboard.writeText(agendaText).then(() => {
                        setCopied(true);
                        setTimeout(() => setCopied(false), 2000);
                      });
                    }}
                    sx={{ fontSize: 15, marginLeft: "12px", cursor: "pointer" }}
                  />
                )}
              </div>
            </div>
          </div>

          {/* Ligne 1 */}
          <div className="grid">
            <div className="col-12 md:col-6">
              <div
                className="p-2 px-0 border-round-sm flex justify-between align-items-left"
                style={{ background: "#f9fafb", borderRadius: "5px" }}
              >
                <span className="font-bold">Nom :</span>
                <span
                  onClick={() => copyToClipboard(tempNom)}
                  className="cursor-pointer"
                >
                  {" "}
                  {tempNom} <ContentCopyIcon sx={{ fontSize: 12 }} />
                </span>
              </div>
            </div>

            <div className="col-12 md:col-6">
              <div
                className="p-2 px-0 border-round-sm flex justify-between align-items-left"
                style={{ background: "#f9fafb", borderRadius: "5px" }}
              >
                <span className="font-bold">Téléphone :</span>
                <span
                  onClick={() => copyToClipboard(tempTel)}
                  className="cursor-pointer"
                >
                  {tempTel} <ContentCopyIcon sx={{ fontSize: 12 }} />
                </span>
              </div>
            </div>
          </div>

          {/* Ligne 3 */}
          <div className="grid">
            <div className="col-12">
              <div
                className="p-2 px-0 border-round-sm flex justify-between align-items-left"
                style={{ background: "#f9fafb", borderRadius: "5px" }}
              >
                <span className="font-bold">Email :</span>
                <span
                  onClick={() => copyToClipboard(tempEmail)}
                  className="cursor-pointer"
                >
                  {tempEmail} <ContentCopyIcon sx={{ fontSize: 12 }} />
                </span>
              </div>
            </div>
          </div>

          <div className="grid">
            {Object.keys(projet).map((key) => {
              if (
                key.startsWith("title_") &&
                projet[key] &&
                parseInt(key.split("_")[1], 10) >= 4
              ) {
                const idx = key.split("_")[1];
                const valueKey = `value_${idx}`;

                if (!projet[valueKey]) return null;

                return (
                  <div key={key} className="col-12">
                    <div
                      className="p-2 px-0 border-round-sm flex justify-between align-items-left"
                      style={{ background: "#f9fafb", borderRadius: "5px" }}
                    >
                      <span className="font-bold">{projet[key]} : </span>
                      <span
                        onClick={() => copyToClipboard(projet[valueKey])}
                        className="cursor-pointer"
                      >
                        {projet[valueKey]}
                        <ContentCopyIcon sx={{ fontSize: 12 }} />
                      </span>
                    </div>
                  </div>
                );
              }
              return null;
            })}
          </div>

          <div className="grid">
            <div className="col-12 md:col-12">
              <div className="py-0 px-0 border-round-sm surface-100 flex flex-column">
                <span className="font-bold">
                  Informations supplémentaires :
                </span>
              </div>
            </div>
          </div>

          <div className="grid">
            <div className="col-12 md:col-12">
              <TextareaAutosize
                variant="standard"
                minRows={5}
                maxRows={10}
                value={infoSup}
                onChange={(e) => setInfoSup(e.target.value)}
                style={{ width: "100%", borderRadius: "5px" }}
                className="mt-2"
              />
            </div>
          </div>

          <div className="grid">
            <div className="col-12 md:col-12">
              <div className="py-0 px-0 border-round-sm surface-100 flex flex-column">
                <span className="font-bold">Ajouter une note :</span>
              </div>
            </div>
          </div>
          <div className="grid">
            <div className="col-12 md:col-12">
              <TextareaAutosize
                variant="standard"
                minRows={5}
                maxRows={10}
                value={note}
                onChange={(e) => setNote(e.target.value)}
                style={{ width: "100%", borderRadius: "5px" }}
                className="mt-2"
              />

              {/* {dateMAJ ? (
                <div className="grid">
                  <div className="col-6 md:col-6">
                    <span>
                      modifié le {formattedDate(dateMAJ)} par {infoMAJ}
                    </span>
                  </div>
                </div>
              ) : (
                <></>
              )} */}
            </div>
          </div>

          <div className="grid">
            <div className="col-12 md:col-12 align-items-right">
              <div className="border-round-sm surface-100 flex flex-column"></div>
              <Button
                label="Enregistrer l'état et la note"
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#029fe4";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "#029fe4";
                }}
                className="w-full text-white"
                style={{
                  background: "#029fe4",
                  border: "1px solid #029fe4",
                  padding: "0.75rem",
                  borderRadius: "5px",
                }}
                onClick={() => {
                  if (etat) {
                    handleSavePhoneCall();
                  }
                }}
              />
            </div>
          </div>
          <FicheLogTerminal idProjet={tempIdProjet} />
        </div>
      </Dialog>

      <DataTable
        value={filtreToute}
        size="small"
        paginator
        rows={25}
        header={enteteTableau5}
        rowsPerPageOptions={[5, 10, 25, 50]}
        tableStyle={{ minWidth: "50rem" }}
        scrollable
        scrollDirection="horizontal"
        dataKey="id"
        selection={selectedRows}
        onSelectionChange={(e) => {
          if (canSelect) setSelectedRows(e.value);
        }}
        selectionMode={canSelect ? "checkbox" : null}
        onRowClick={() => null}
        rowSelectable={() => canSelect}
        paginatorTemplate={
          "FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown"
        }
        emptyMessage="Aucune fiche pour le moment"
        paginatorRight={
          <span style={{ margin: "10px", fontWeight: "bold" }}>
            Résultats : {filtreToute.length}
          </span>
        }
      >
        {canSelect && (
          <Column
            selectionMode="multiple"
            headerStyle={{ width: "3rem" }}
          ></Column>
        )}
        <Column
          header="Date"
          field="date"
          bodyStyle={{ fontSize: "14px" }}
          body={(rowData) => {
            if (!rowData.date || rowData.date === "0000-00-00") {
              return <span>Non fixé </span>;
            }
            const date = new Date(rowData.date);
            const day = String(date.getDate()).padStart(2, "0");
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const year = date.getFullYear();

            return (
              <span>
                {day}/{month}/{year}
              </span>
            );
          }}
        />{" "}
        <Column header="Catégorie" field="category_title" />
        <Column
          style={{ cursor: "pointer" }}
          header="Client"
          field="value_1"
          bodyStyle={{ fontSize: "14px" }}
          body={(rowData) => (
            <div>
              <span
                onClick={() => {
                  copyToClipboard(rowData.value_1);
                }}
              >
                {rowData.value_1}
              </span>
            </div>
          )}
        />
        <Column
          style={{ cursor: "pointer" }}
          header="Téléphone"
          field="value_2"
          bodyStyle={{ fontSize: "14px" }}
          body={(rowData) => (
            <div>
              <span
                onClick={() => {
                  copyToClipboard(rowData.value_2);
                }}
              >
                {rowData.value_2}
              </span>
            </div>
          )}
        />
        <Column
          style={{ cursor: "pointer" }}
          header="Email"
          field="value_3"
          bodyStyle={{ fontSize: "14px" }}
          body={(rowData) => (
            <div>
              <span
                onClick={() => {
                  copyToClipboard(rowData.value_3);
                }}
              >
                {rowData.value_3}
              </span>
            </div>
          )}
        />
        <Column
          field="enLigne"
          header="En ligne"
          style={{ textAlign: "left", width: "120px" }}
          body={(rowData) => (
            <Checkbox
              checked={rowData.enLigne == 1}
              onChange={(e) => mettreEnligne(rowData, e.checked)}
            />
          )}
        />
        <Column
          header="Etat"
          field="etat"
          bodyStyle={{ fontSize: "14px" }}
          body={(rowData) => {
            const etatFinal = rowData.etat;
            const label = `${mapEtatFiche(etatFinal)}`;

            return (
              <div>
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "4px",
                  }}
                >
                  <Tag
                    value={label}
                    style={{
                      backgroundColor: rowData.color,
                      color: "#fff",
                      padding: "4px 12px",
                      borderRadius: "8px",
                      fontWeight: "bold",
                    }}
                  ></Tag>
                </span>
              </div>
            );
          }}
        />
        <Column
          field="tel"
          header="Dernier MAJ"
          bodyStyle={{ fontSize: "14px" }}
          body={(rowData) => {
            if (!rowData.dateUpdate) return null;

            const date = new Date(rowData.dateUpdate);
            const day = String(date.getDate()).padStart(2, "0");
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const year = date.getFullYear();

            return (
              <span>
                {day}/{month}/{year} <br />
                {rowData.adminMod}
              </span>
            );
          }}
        />
        <Column
          header="Actions"
          style={{ textAlign: "center", width: "100px" }}
          body={(rowData) => (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "5px",
              }}
            >
              <Button
                icon="pi pi-whatsapp"
                severity="success"
                size="small"
                onClick={() => {
                  let message = "";

                  Object.keys(rowData).forEach((key) => {
                    if (key.startsWith("title_") && rowData[key]) {
                      const idx = key.split("_")[1];
                      const valueKey = `value_${idx}`;

                      if (rowData[valueKey]) {
                        const title = rowData[key].trim();
                        const value = rowData[valueKey].trim();
                        message += `*${title}* : ${value}\n`;
                      }
                    }
                  });

                  if (!message) {
                    message = "Aucune donnée à envoyer.";
                  }

                  const url = `https://api.whatsapp.com/send?text=${encodeURIComponent(
                    message
                  )}`;
                  window.open(url, "_blank");
                }}
              />

              <PdfButton rowData={rowData} />

              <Button
                icon="pi pi-phone"
                severity="info"
                size="small"
                onClick={() => {
                  setInfoClick(rowData.id);
                }}
              />
            </div>
          )}
        />
      </DataTable>
    </>
  );
}
